import { type FC } from 'react';
import { Link } from 'dibs-elements/exports/Link';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';
import EmptyTagIcon from 'dibs-icons/exports/legacy/TagEmpty';

import styles from './PhotoDetails.scss';

export type TagType = {
    name: string | null;
    urlLabel: string | null;
};

type TagLinkProps = {
    type: 'style' | 'room';
    tag: TagType;
};

const TagLink: FC<TagLinkProps> = props => {
    const { tag, type } = props;
    return <Link href={`/photos/${type}/${tag.urlLabel}/`}>{tag.name}</Link>;
};

const isValidTagLink = (tag?: TagType | null): tag is TagType => {
    return !!tag?.name && !!tag?.urlLabel;
};

type Props = {
    styleTag?: TagType | null;
    roomTag?: TagType | null;
    photoName: string;
    isInModal?: boolean;
};

const PhotoDetails: FC<Props> = ({ styleTag, roomTag, photoName, isInModal }) => {
    const styleTagElement = isValidTagLink(styleTag) && <TagLink tag={styleTag} type="style" />;
    const roomTagElement = isValidTagLink(roomTag) && <TagLink tag={roomTag} type="room" />;

    let tagLinks = null;
    if (styleTagElement || roomTagElement) {
        tagLinks = (
            <>
                {styleTagElement}
                {styleTagElement && roomTagElement && ', '}
                {roomTagElement}
            </>
        );
    }

    return (
        <div className={styles.wrapper}>
            {isInModal ? (
                <HeadingLevel>
                    {Heading => <Heading className={styles.title}>{photoName}</Heading>}
                </HeadingLevel>
            ) : (
                <h1 className={styles.title}>{photoName}</h1>
            )}

            <div className={styles.links}>
                {tagLinks && (
                    <>
                        <EmptyTagIcon className={styles.tagIcon} />
                        {tagLinks}
                    </>
                )}
            </div>
        </div>
    );
};

export default PhotoDetails;
